<template>
  <div class="hcPage">
    <!-- 头部：深宝蓝 + 金色光晕 -->
    <div class="hcHero">
      <i class="hcBack" @click="$router.back()"></i>
      <div class="hcTitle">帮助中心</div>
      <div class="hcHi">
        <span class="hcAvatar">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 13v-1a7 7 0 0 1 14 0v1" />
            <rect x="3.4" y="13" width="3.6" height="5.6" rx="1.2" />
            <rect x="17" y="13" width="3.6" height="5.6" rx="1.2" />
            <path d="M19 18.6a4 4 0 0 1-4 3.1h-2" />
          </svg>
        </span>
        <div class="hcHiTxt">
          <div class="hcHiName">Hi，尊敬的会员用户</div>
          <div class="hcHiSub">{{ greet }}，欢迎来到帮助中心</div>
        </div>
      </div>
      <div class="hcTip">若相关问题仍未解决，可咨询在线客服</div>
    </div>

    <!-- 菜单卡 -->
    <div class="hcCard">
      <div class="hcRow" v-for="(m, i) in menus" :key="i" @click="$parent.goNav('/boutBallBetInfo?type=' + m.type)">
        <span class="hcIco" v-html="m.icon"></span>
        <span class="hcName">{{ m.name }}</span>
        <span class="hcArrow"></span>
      </div>
    </div>

    <div class="hcFoot">没有找到解决办法？请联系<a @click="$parent.openKefu">人工客服</a>解决</div>
  </div>
</template>
<script>
export default {
  name: 'boutBallBet',
  data() {
    var ico = t =>
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + t + '</svg>';
    return {
      // 1常见问题 2隐私政策 3免责说明 4联系我们 5代理加盟 7关于我们 8博彩责任
      menus: [
        { type: 7, name: '关于我们', icon: ico('<circle cx="12" cy="12" r="9"/><line x1="12" y1="11" x2="12" y2="16"/><circle cx="12" cy="8" r="0.7" fill="currentColor" stroke="none"/>') },
        { type: 1, name: '常见问题', icon: ico('<circle cx="12" cy="12" r="9"/><path d="M9.4 9.3a2.7 2.7 0 0 1 5.1 1c0 1.8-2.4 2-2.4 3.2"/><circle cx="12" cy="17" r="0.7" fill="currentColor" stroke="none"/>') },
        { type: 2, name: '隐私政策', icon: ico('<path d="M12 3l7 3v5c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6z"/><path d="M9.2 12l2 2 3.6-3.8"/>') },
        { type: 3, name: '免责说明', icon: ico('<path d="M7 3h7l4 4v14H7z"/><path d="M14 3v4h4"/><line x1="9.6" y1="12.2" x2="15" y2="12.2"/><line x1="9.6" y1="15.6" x2="15" y2="15.6"/>') },
        { type: 4, name: '联系我们', icon: ico('<path d="M5 13v-1a7 7 0 0 1 14 0v1"/><rect x="3.6" y="13" width="3.4" height="5.4" rx="1.1"/><rect x="17" y="13" width="3.4" height="5.4" rx="1.1"/><path d="M19 18.4a4 4 0 0 1-4 3.1h-2"/>') },
        { type: 5, name: '代理加盟', icon: ico('<circle cx="9" cy="8.5" r="3"/><path d="M3.6 19a5.4 5.4 0 0 1 10.8 0"/><path d="M16 6a3 3 0 0 1 0 6M17.4 19a5.4 5.4 0 0 0-2.9-4.8"/>') },
        { type: 8, name: '博彩责任', icon: ico('<path d="M12 20.5C7 18 4 14.5 4 10.2 4 7.5 6 5.5 8.4 5.5c1.5 0 2.8.8 3.6 2 .8-1.2 2.1-2 3.6-2C18 5.5 20 7.5 20 10.2c0 4.3-3 7.8-8 10.3z"/>') },
      ],
    };
  },
  computed: {
    greet() {
      var h = new Date().getHours();
      if (h < 6) return '凌晨好';
      if (h < 11) return '早上好';
      if (h < 14) return '中午好';
      if (h < 18) return '下午好';
      return '晚上好';
    },
  },
};
</script>

<style lang="scss" scoped>
.hcPage {
  min-height: 100vh;
  background: #f7f8fa;
}
.hcHero {
  position: relative;
  padding: 16px 18px 24px;
  color: #fff;
  background: linear-gradient(160deg, #10275a 0%, #1c48c0 58%, #1e50e0 100%);
  border-radius: 0 0 22px 22px;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    right: -34px;
    top: -34px;
    width: 170px;
    height: 170px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(230, 200, 119, 0.4), transparent 70%);
    pointer-events: none;
  }
  &::after {
    content: '';
    position: absolute;
    left: -20px;
    bottom: -40px;
    width: 130px;
    height: 130px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.14), transparent 70%);
    pointer-events: none;
  }
}
.hcBack {
  position: absolute;
  left: 18px;
  top: 18px;
  width: 11px;
  height: 11px;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(45deg);
  z-index: 2;
}
.hcTitle {
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  height: 24px;
  line-height: 24px;
  position: relative;
  z-index: 1;
}
.hcHi {
  display: flex;
  align-items: center;
  margin-top: 18px;
  position: relative;
  z-index: 1;
}
.hcAvatar {
  width: 54px;
  height: 54px;
  flex: 0 0 54px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: 1.5px solid rgba(230, 200, 119, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  box-shadow: 0 0 18px rgba(230, 200, 119, 0.3);
  color: #e6c877;
  svg {
    width: 28px;
    height: 28px;
  }
}
.hcHiName {
  font-size: 16px;
  font-weight: 700;
}
.hcHiSub {
  font-size: 12px;
  opacity: 0.85;
  margin-top: 5px;
}
.hcTip {
  margin-top: 16px;
  text-align: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.82);
  border-top: 1px solid rgba(255, 255, 255, 0.18);
  padding-top: 12px;
  position: relative;
  z-index: 1;
}
.hcCard {
  width: 90%;
  margin: 16px auto 0;
  background: #fff;
  border-radius: 16px;
  padding: 2px 14px;
  box-sizing: border-box;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05), 0 8px 20px rgba(16, 24, 40, 0.06);
}
.hcRow {
  display: flex;
  align-items: center;
  height: 54px;
  border-bottom: 1px solid #f1f3f6;
  cursor: pointer;
  &:last-child {
    border-bottom: none;
  }
  &:active {
    opacity: 0.7;
  }
}
.hcIco {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  border-radius: 10px;
  background: linear-gradient(135deg, #e6c877, #c69a3f);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 8px rgba(198, 154, 63, 0.3);
  color: #fff;
  ::v-deep svg {
    width: 19px;
    height: 19px;
  }
}
.hcName {
  flex: 1;
  margin-left: 12px;
  font-size: 14px;
  color: #0f172a;
  font-weight: 500;
}
.hcArrow {
  width: 8px;
  height: 8px;
  border-top: 2px solid #c8cdd6;
  border-right: 2px solid #c8cdd6;
  transform: rotate(45deg);
}
.hcFoot {
  text-align: center;
  color: #94a3b8;
  font-size: 12px;
  padding: 22px 0 30px;
  a {
    color: #c69a3f;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/boutBallBet.vue